import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ShopTheming, ThemingService } from 'src/app/theming.service';
import { LambdaService } from 'src/app/lambda.service';


@Component({
  selector: 'app-policies-section',
  templateUrl: './policies-section.component.html',
  styleUrls: ['./policies-section.component.scss']
})
export class PoliciesSectionComponent implements OnInit {
  loading = false;
  public shopTheme: ShopTheming[] = [];
  shopInfo: any = {};

  constructor(
      private router: Router,
      private themingService: ThemingService,
      private lambdaService: LambdaService
    ) {
      this.shopTheme = this.themingService.shopTheming;
    }

  ngOnInit(): void {
    this.getShopData();
  }

   getShopData(){
    this.lambdaService
    .getShopData(this.themingService.shopId)
    .then((data: any) => {
      this.shopInfo = data.info[0] || {};
      this.shopInfo = data.info[0];

  })
    .catch((error: Error) => {
      console.error(error);
    })
    .finally(() => {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    });
  }

}
